/* eslint-disable no-unused-vars */
import React, { useRef, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import CodeList from "../../lib/CodeList";
import Utilities from "../../lib/Utilities";

const codeList = new CodeList();
const util = new Utilities();

export default function StoreDetailContact(props) {
  const {
    loginInfo,
    currentView,
    navHeight,
    selectedStore,
    clearSelectedStore,
    copyUrl,
    goToInquiry,
    setIsContactView,
    isContactView,
    openImageSlide,
    INSERT_STORE_INQUIRY,
    storeReviewList,
    isLogiWork,
  } = props;

  const [mobile, setMobile] = useState(false);
  const { t } = useTranslation();

  const controller = {
    srKey: useRef(), //창고 키
    srType: useRef(), // 문의종류
    srGoods: useRef(), // 화물종류
    srPacking: useRef(), // 포장상태
    srInOutType: useRef(), // 보광장소
    srCustomsYN: useRef(), // 보세여부
    srStartDate: useRef(), // 보관 예정 시작
    srEndDate: useRef(), // 보관 예정 종료
    srUserName: useRef(), // 회신 담당자명
    srEmail: useRef(), // 회신 이메일
    srMobile: useRef(), // 회신 전화번호
    srDesc: useRef(), // 문의내용
  };

  const sdTypeKind = {
    A: t("storeMall.storeDetail.boundedWareHouse"),
    B: t("storeMall.storeDetail.generalWareHouse"),
  };
  const sdTypeGoods = {
    A: t("storeMall.storeDetail.dry"),
    B: t("storeMall.storeDetail.refrigerated"),
    C: t("storeMall.storeDetail.frozen"),
    D: t("storeMall.storeDetail.heated"),
    E: t("storeMall.storeDetail.quarantineItems"),
    F: t("storeMall.storeDetail.marineProducts"),
    G: t("storeMall.storeDetail.hazardousMaterials"),
  };

  useEffect(() => {
    checkUserAgent();
  }, []);

  useEffect(() => {
    if (loginInfo !== null) {
      if (controller.srKey.current) {
        controller.srUserName.current.value = loginInfo.user_nm;
        controller.srEmail.current.value = loginInfo.user_id;
        controller.srMobile.current.value = loginInfo.user_tel;
      }
    }
  }, [loginInfo]);

  function checkUserAgent() {
    let UserAgent = navigator.userAgent;

    if (
      UserAgent.match(
        /iPhone|iPod|Android|Windows CE|BlackBerry|Symbian|Windows Phone|webOS|Opera Mini|Opera Mobi|POLARIS|IEMobile|lgtelecom|nokia|SonyEricsson/i
      ) != null ||
      UserAgent.match(/LG|SAMSUNG|Samsung/) != null
    ) {
      setMobile(true);
    } else {
      setMobile(false);
    }
  }

  function clearInquiryInput() {
    for (let key in controller) {
      if (key !== "srKey") {
        controller[key].current.value = "";
      }
    }
  }

  function actionSubmit() {
    let uploadData = {};
    for (let key in controller) {
      if (controller[key].current) {
        uploadData[key] = controller[key].current.value
          ? controller[key].current.value
          : "";
      }
    }
    INSERT_STORE_INQUIRY(uploadData);
  }

  function requestEnquiry(managerCompCD, managerID) {
    if (loginInfo) {
      codeList.Modal.current.confirm(t("commonMSG.talkOnLogiTalk"), (ret) => {
        if (ret) {
          localStorage.setItem("enquiryManager", "Z0001|hskim@gbts.co.kr");
          window.open("/LogiTalk", "_blank", "width=1200, height=800");
        } else {
          codeList.Modal.current.alert(t("commonMSG.cancelTalk"));
        }
      });
    } else {
      codeList.Modal.current.alert(t("commonMSG.requiresLogin"));
    }
  }

  return (
    <div
      className="d-inline-block bg-white border-left shadow-sm d-flex flex-column position-fixed"
      style={{
        height: isLogiWork ? "100vh" : "calc(100vh - " + navHeight + "px)",
        minWidth: currentView !== 2 ? 400 : "100vw",
        width: currentView !== 2 ? 400 : "100vw",
        right: 0,
        top: isLogiWork ? 0 : navHeight,
        zIndex: 999,
      }}
    >
      <div className="d-flex flex-row justify-content-between align-items-center text-secondary font-weight-bold w-100 border-bottom py-1 px-3 ">
        <p className="h6 overflow-hidden text-freiscop text-truncate font-weight-bold m-0 p-0 flex-fill">
          {selectedStore.smName}
        </p>
        <h2
          className="cursor_pointer m-0 p-0 px-2"
          onClick={clearSelectedStore}
        >
          &times;
        </h2>
      </div>
      <div className="overflow_scroll" id="storeDetail">
        <div className="border-bottom p-5 text-center">
          <p className="h6 overflow-hidden text-dark text-truncate font-weight-bold m-0 p-0">
            {selectedStore.smName}
          </p>
          <div className="d-flex flex-row justify-content-center mt-2">
            <div
              className="btn btn-sm btn-info font-size-09 mr-2"
              onClick={() => {
                copyUrl();
              }}
            >
              {t("storeMall.storeDetail.share")}{" "}
              <i className="fa-solid fa-share-from-square ml-1 font-size-09" />
            </div>
            <div
              className="btn btn-sm btn-outline-info font-size-09"
              onClick={() => {
                goToInquiry();
              }}
            >
              {t("storeMall.storeDetail.inquiry.title")}{" "}
              <i className="fa-solid fa-arrow-down-long ml-1" />
            </div>
          </div>
        </div>

        <div className="p-3">
          <div>
            <p className="h6 border-bottom border-dark py-2 px-1 m-0  font-weight-bold">
              {t("storeMall.storeDetail.reviewModal.title")}
            </p>
            <div className="m-0 p-0 w-100 mb-3">
              {storeReviewList.length > 0 ? (
                storeReviewList.slice(0, 3).map((review) => {
                  return (
                    <div
                      className="d-flex flex-row justify-content-start border-bottom py-3"
                      key={review.srIDX}
                    >
                      <span style={{ minWidth: 80 }}>{review.srUserName}</span>
                      <span className="flex-fill overflow_hidden text-truncate mx-2">
                        {review.isShow
                          ? review.srReviewText
                          : t(
                              "storeMall.storeDetail.reviewModal.msg.privateReview"
                            )}
                      </span>
                      <span style={{ minWidth: 50 }}>
                        <i className="icon-star text-warning" />
                        {review.srRating}
                      </span>
                      <span style={{ minWidth: 80 }}>
                        {review.srEditDate.split(" ")[0]}
                      </span>
                    </div>
                  );
                })
              ) : (
                <p className="p-3 text-center bg-light rounded mt-2">
                  {t("storeMall.storeDetail.reviewModal.msg.noReview")}
                </p>
              )}
            </div>
            <div className="d-flex flex-row justify-content-center">
              <button
                type="button"
                className="btn btn-sm btn-info font-size-09"
                data-toggle="modal"
                data-target="#StoreReviewModal"
              >
                {t("storeMall.storeDetail.reviewModal.btnReview")}
              </button>
            </div>
          </div>
        </div>

        <div className="p-3">
          <div>
            <p className="h6 border-bottom border-dark py-2 px-1 m-0  font-weight-bold">
              {t("storeMall.storeDetail.storeInfo.title")}
            </p>

            <div className="border-bottom row py-3 m-0">
              <div className="col-4 p-0 m-0">
                {t("storeMall.storeDetail.storeInfo.compName")}
              </div>
              <div className="col p-0 pl-1 m-0 font-weight-bold text-secondary">
                {selectedStore.smName}
              </div>
            </div>
            <div className="border-bottom row py-3 m-0">
              <div className="col-4 p-0 m-0">
                {t("storeMall.storeDetail.storeInfo.customs")}
              </div>
              <div className="col p-0 pl-1 m-0 font-weight-bold text-secondary">
                {selectedStore.smCustoms}
              </div>
            </div>
            <div className="border-bottom row py-3 m-0">
              <div className="col-4 p-0 m-0">
                {t("storeMall.storeDetail.storeInfo.tel")}
              </div>
              <div className="col p-0 pl-1 m-0 font-weight-bold text-secondary">
                {util.telFormatConvert(selectedStore.smTel)}
              </div>
            </div>
            <div className="border-bottom row py-3 m-0">
              <div className="col-4 p-0 m-0">
                {t("storeMall.storeDetail.storeInfo.businessHours")}
              </div>
              <div className="col p-0 pl-1 m-0 font-weight-bold text-secondary">
                {selectedStore.sdWorkingTime}
              </div>
            </div>
            <div className="border-bottom row py-3 m-0">
              <div className="col-4 p-0 m-0">
                {t("storeMall.storeDetail.storeInfo.address")}
              </div>
              <div className="col p-0 pl-1 m-0 font-weight-bold text-secondary">
                <p>{selectedStore.smAddrFull}</p>
                <div className="mt-2 d-flex flex-row align-items-center">
                  <a
                    className="d-inline-flex flex-row align-items-center btn btn-sm btn-outline-secondary bg-white text-secondary font-size-09 mr-1"
                    href={`https://map.kakao.com/link/to/${selectedStore.smName},${selectedStore.lat},${selectedStore.lng}`}
                    target="_blank"
                  >
                    <div
                      className="d-inline-block"
                      style={{
                        background: `url(https://gbts-invoice.s3.ap-northeast-2.amazonaws.com/talk/chatRoom/Z0001/amber.jung@buddible.com/20250821170739_img_snb.png) 50% 50%/contain no-repeat`,
                        width: 90,
                        height: 20,
                      }}
                    />
                  </a>

                  <a
                    className="d-inline-flex flex-row align-items-center btn btn-sm btn-outline-secondary bg-white text-secondary font-weight-bold font-size-09"
                    href={
                      mobile
                        ? `nmap://route/car?dlat=${selectedStore.lat}&dlng=${selectedStore.lng}&dname=${selectedStore.smName}&appname=gbts.co.kr`
                        : `http://map.naver.com/index.nhn?elng=${selectedStore.lng}&elat=${selectedStore.lat}&pathType=0&showMap=true&etext=${selectedStore.smName}&menu=route`
                    }
                    target="_blank"
                  >
                    <div
                      style={{
                        background: `url(
                            "https://gbts-invoice.s3.ap-northeast-2.amazonaws.com/talk/chatRoom/Z0001/amber.jung@buddible.com/20250821171227_home.png"
                          ) 50% 50%/contain no-repeat`,
                        width: 21,
                        height: 21,
                      }}
                    />
                    {t("storeMall.storeDetail.storeInfo.directions")}
                  </a>
                </div>
              </div>
            </div>
            <div className="border-bottom row py-3 m-0">
              <div
                className="col-4 p-0 m-0"
                onClick={() => {
                  setIsContactView(!isContactView);
                }}
              >
                {t("storeMall.storeDetail.storeInfo.employeeInfo")}
                {isContactView ? (
                  <i className="fa-solid fa-angle-up ml-1" />
                ) : (
                  <i className="fa-solid fa-angle-down ml-1" />
                )}
              </div>
              <div className="col p-0 pl-1 m-0 font-weight-bold text-secondary">
                {!selectedStore.sdContact1 &&
                  !selectedStore.sdContact2 &&
                  !selectedStore.sdContact3 &&
                  !selectedStore.sdContact4 &&
                  t("storeMall.storeDetail.storeInfo.noEmployee")}
                {isContactView && (
                  <div>
                    {selectedStore.sdContact1 && (
                      <div className="p-0">
                        <div className="border-bottom p-2">
                          {selectedStore.sdContact1 && (
                            <p className="mb-1 p-0 text-secondary">
                              -{" "}
                              {t(
                                "storeMall.storeDetail.storeInfo.employeeName"
                              )}{" "}
                              : {selectedStore.sdContact1}
                            </p>
                          )}
                          {selectedStore.sdContact1Tel && (
                            <p className="mb-1 p-0 text-secondary">
                              -{" "}
                              {t("storeMall.storeDetail.storeInfo.employeeTel")}{" "}
                              : {selectedStore.sdContact1Tel}{" "}
                            </p>
                          )}
                          {selectedStore.sdContact1Email && (
                            <p className="mb-1 p-0 text-secondary">
                              -{" "}
                              {t(
                                "storeMall.storeDetail.storeInfo.employeeEmail"
                              )}{" "}
                              : {selectedStore.sdContact1Email}{" "}
                            </p>
                          )}
                          {selectedStore.sdContact1CompCD &&
                            selectedStore.sdContact1UserID && (
                              <div
                                className="btn btn-sm btn-outline-info font-size-09"
                                onClick={() => {
                                  requestEnquiry(
                                    selectedStore.sdContact1CompCD,
                                    selectedStore.sdContact1UserID
                                  );
                                }}
                              >
                                {t(
                                  "storeMall.storeDetail.storeInfo.inquiryOnLogiTalk"
                                )}
                              </div>
                            )}
                        </div>
                      </div>
                    )}
                    {selectedStore.sdContact2 && (
                      <div className="p-0">
                        <div className="border-bottom p-2">
                          {selectedStore.sdContact2 && (
                            <p className="mb-1 p-0 text-secondary">
                              -{" "}
                              {t(
                                "storeMall.storeDetail.storeInfo.employeeName"
                              )}{" "}
                              : {selectedStore.sdContact2}
                            </p>
                          )}
                          {selectedStore.sdContact2Tel && (
                            <p className="mb-1 p-0 text-secondary">
                              -{" "}
                              {t("storeMall.storeDetail.storeInfo.employeeTel")}{" "}
                              : {selectedStore.sdContact2Tel}{" "}
                            </p>
                          )}
                          {selectedStore.sdContact2Email && (
                            <p className="mb-1 p-0 text-secondary">
                              -{" "}
                              {t(
                                "storeMall.storeDetail.storeInfo.employeeEmail"
                              )}
                              : {selectedStore.sdContact2Email}{" "}
                            </p>
                          )}
                          {selectedStore.sdContact2CompCD &&
                            selectedStore.sdContact2UserID &&
                            loginInfo !== null && (
                              <Link
                                to="LogiTalk"
                                className="btn btn-sm btn-outline-info font-size-09"
                                onClick={() => {
                                  requestEnquiry(
                                    selectedStore.sdContact2CompCD,
                                    selectedStore.sdContact2UserID
                                  );
                                }}
                              >
                                {t(
                                  "storeMall.storeDetail.storeInfo.inquiryOnLogiTalk"
                                )}
                              </Link>
                            )}
                        </div>
                      </div>
                    )}
                    {selectedStore.sdContact3 && (
                      <div className="p-0">
                        <div className="border-bottom p-2">
                          {selectedStore.sdContact3 && (
                            <p className="mb-1 p-0 text-secondary">
                              -{" "}
                              {t(
                                "storeMall.storeDetail.storeInfo.employeeName"
                              )}{" "}
                              : {selectedStore.sdContact3}
                            </p>
                          )}
                          {selectedStore.sdContact3Tel && (
                            <p className="mb-1 p-0 text-secondary">
                              -{" "}
                              {t("storeMall.storeDetail.storeInfo.employeeTel")}{" "}
                              : {selectedStore.sdContact3Tel}{" "}
                            </p>
                          )}
                          {selectedStore.sdContact3Email && (
                            <p className="mb-1 p-0 text-secondary">
                              -{" "}
                              {t(
                                "storeMall.storeDetail.storeInfo.employeeEmail"
                              )}{" "}
                              : {selectedStore.sdContact3Email}{" "}
                            </p>
                          )}
                          {selectedStore.sdContact3CompCD &&
                            selectedStore.sdContact3UserID &&
                            loginInfo !== null && (
                              <Link
                                to="/LogiTalk"
                                className="btn btn-sm btn-outline-info font-size-09"
                                onClick={() => {
                                  requestEnquiry(
                                    selectedStore.sdContact3CompCD,
                                    selectedStore.sdContact3UserID
                                  );
                                }}
                              >
                                {" "}
                                {t(
                                  "storeMall.storeDetail.storeInfo.inquiryOnLogiTalk"
                                )}
                              </Link>
                            )}
                        </div>
                      </div>
                    )}
                    {selectedStore.sdContact4 && (
                      <div className="p-0">
                        <div className="p-2">
                          {selectedStore.sdContact4 && (
                            <p className="mb-1 p-0 text-secondary">
                              -{" "}
                              {t(
                                "storeMall.storeDetail.storeInfo.employeeName"
                              )}{" "}
                              : {selectedStore.sdContact4}
                            </p>
                          )}
                          {selectedStore.sdContact4Tel && (
                            <p className="mb-1 p-0 text-secondary">
                              -{" "}
                              {t("storeMall.storeDetail.storeInfo.employeeTel")}{" "}
                              : {selectedStore.sdContact4Tel}{" "}
                            </p>
                          )}
                          {selectedStore.sdContact4Email && (
                            <p className="mb-1 p-0 text-secondary">
                              -{" "}
                              {t(
                                "storeMall.storeDetail.storeInfo.employeeEmail"
                              )}{" "}
                              : {selectedStore.sdContact4Email}{" "}
                            </p>
                          )}
                          {selectedStore.sdContact4CompCD &&
                            selectedStore.sdContact4UserID &&
                            loginInfo !== null && (
                              <Link
                                to="/LogiTalk"
                                className="btn btn-sm btn-outline-info font-size-09"
                                onClick={() => {
                                  requestEnquiry(
                                    selectedStore.sdContact4CompCD,
                                    selectedStore.sdContact4UserID
                                  );
                                }}
                              >
                                {t(
                                  "storeMall.storeDetail.storeInfo.inquiryOnLogiTalk"
                                )}
                              </Link>
                            )}
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="p-3">
          <div>
            <p className="h6 border-bottom border-dark py-2 px-1 m-0  font-weight-bold">
              {t("storeMall.storeDetail.storeInfo.images")}
            </p>
            <div className="m-0 p-0 w-100 d-flex flex-row flex-wrap justify-content-start py-2">
              {!selectedStore.sdPhoto && (
                <div className="w-100 p-3 text-center bg-light rounded">
                  {t("storeMall.storeDetail.storeInfo.noImages")}
                </div>
              )}

              {selectedStore.sdPhoto &&
                selectedStore.sdPhoto.split("|").map((photo, index) => {
                  let splitData = photo.split("?");
                  let imgLink = splitData[0];
                  return (
                    <div
                      key={index}
                      className="p-1"
                      style={{
                        width: "33.3333%",
                        height: 100,
                      }}
                    >
                      <div
                        className="w-100 h-100 cursor_pointer bg-light rounded border"
                        style={{
                          background: `url(${imgLink}) 50% 50%/cover no-repeat`,
                        }}
                        onClick={() => {
                          openImageSlide(index);
                        }}
                      />
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
        <div className="p-3">
          <div>
            <p className="h6 border-bottom border-dark py-2 px-1 m-0 font-weight-bold">
              {t("storeMall.storeDetail.storeDetailInfo.title")}
            </p>

            <div className="border-bottom row py-3 m-0">
              <div className="col-4 p-0 m-0">
                {t("storeMall.storeDetail.storeDetailInfo.classification")}
              </div>
              <div className="col p-0 pl-1 m-0 font-weight-bold text-secondary">
                {selectedStore.sdTypeKind
                  ? selectedStore.sdTypeKind
                      .split("|")
                      .map((kind) => <span>{sdTypeKind[kind]}</span>)
                  : "-"}
              </div>
            </div>

            <div className="border-bottom row py-3 m-0">
              <div className="col-4 p-0 m-0">
                {t("storeMall.storeDetail.storeDetailInfo.handledCargo")}
              </div>
              <div className="col p-0 pl-1 m-0 font-weight-bold text-secondary">
                {selectedStore.sdTypeGoods
                  ? selectedStore.sdTypeGoods
                      .split("|")
                      .map(
                        (goods, index) =>
                          `${sdTypeGoods[goods]}${
                            selectedStore.sdTypeGoods.split("|").length - 1 >
                            index
                              ? ", "
                              : ""
                          }`
                      )
                  : "-"}
              </div>
            </div>

            <div className="border-bottom row py-3 m-0">
              <div className="col-4 p-0 m-0">
                {t("storeMall.storeDetail.storeDetailInfo.indoorArea")}
              </div>
              <div className="col p-0 pl-1 m-0 font-weight-bold text-secondary">
                {selectedStore.sdExtentInside || "-"}
              </div>
            </div>

            <div className="border-bottom row py-3 m-0">
              <div className="col-4 p-0 m-0">
                {t("storeMall.storeDetail.storeDetailInfo.outdoorArea")}
              </div>
              <div className="col p-0 pl-1 m-0 font-weight-bold text-secondary">
                {selectedStore.sdExtentOutside || "-"}
              </div>
            </div>

            <div className="border-bottom row py-3 m-0">
              <div className="col-4 p-0 m-0">
                {t("storeMall.storeDetail.storeDetailInfo.indoorStorableCargo")}
              </div>
              <div className="col p-0 pl-1 m-0 font-weight-bold text-secondary">
                {selectedStore.sdGoodsInside || "-"}
              </div>
            </div>

            <div className="border-bottom row py-3 m-0">
              <div className="col-4 p-0 m-0">
                {t(
                  "storeMall.storeDetail.storeDetailInfo.outdoorStorableCargo"
                )}
              </div>
              <div className="col p-0 pl-1 m-0 font-weight-bold text-secondary">
                {selectedStore.sdGoodsOutside || "-"}
              </div>
            </div>

            <div className="border-bottom row py-3 m-0">
              <div className="col-4 p-0 m-0">
                {t("storeMall.storeDetail.storeDetailInfo.securityEquipment")}
              </div>
              <div className="col p-0 pl-1 m-0 font-weight-bold text-secondary">
                {selectedStore.sdSecurity || "-"}
              </div>
            </div>

            <div className="border-bottom row py-3 m-0">
              <div className="col-4 p-0 m-0">
                {t("storeMall.storeDetail.storeDetailInfo.insuranceStatus")}
              </div>
              <div className="col p-0 pl-1 m-0 font-weight-bold text-secondary">
                {selectedStore.sdInsure || "-"}
              </div>
            </div>
          </div>
        </div>
        <div className="p-3">
          <div>
            <p className="h6 border-bottom border-dark py-2 px-1 m-0 font-weight-bold">
              {t("storeMall.storeDetail.storeETCMemo")}
            </p>

            <div className="border-bottom row py-3 m-0">
              {selectedStore.sdEtcMemo}
            </div>
          </div>
        </div>
        <div className="p-3">
          <p className="h6 border-bottom border-dark py-2 px-1 m-0 font-weight-bold mb-3">
            {t("storeMall.storeDetail.inquiry.title")}
          </p>

          <div className="px-3">
            <div className="mb-3 row d-flex flex-row align-items-center">
              <label className="col-form-label col-sm-3 text-end m-0 p-0 align-self-start pt-2">
                {t("storeMall.storeDetail.inquiry.warehouseId")}
                <i style={{ color: "red", fontWeight: 700 }}>*</i>
              </label>
              <div className="col-sm-9 m-0 p-0 pl-2">
                <input
                  disabled
                  type="text"
                  className="form-control"
                  placeholder={t(
                    "storeMall.storeDetail.inquiry.warehouseIdPlaceholder"
                  )}
                  ref={controller.srKey}
                  value={selectedStore.smKey}
                />
              </div>
            </div>
          </div>

          <div className="px-3">
            <div className="mb-3 row d-flex flex-row align-items-center">
              <label className="col-form-label col-sm-3 text-end m-0 p-0 align-self-start pt-2">
                {t("storeMall.storeDetail.inquiry.inquiryType")}
                <i style={{ color: "red", fontWeight: 700 }}>*</i>
              </label>
              <div className="col-sm-9 m-0 p-0 pl-2">
                <input
                  type="text"
                  className="form-control"
                  placeholder={t(
                    "storeMall.storeDetail.inquiry.inquiryTypePlaceholder"
                  )}
                  ref={controller.srType}
                />
              </div>
            </div>
          </div>

          <div className="px-3">
            <div className="mb-3 row d-flex flex-row align-items-center">
              <label className="col-form-label col-sm-3 text-end m-0 p-0 align-self-start pt-2">
                {t("storeMall.storeDetail.inquiry.cargoType")}
              </label>
              <div className="col-sm-9 m-0 p-0 pl-2">
                <input
                  type="text"
                  className="form-control"
                  placeholder={t(
                    "storeMall.storeDetail.inquiry.cargoTypePlaceholder"
                  )}
                  ref={controller.srGoods}
                />
              </div>
            </div>
          </div>

          <div className="px-3">
            <div className="mb-3 row d-flex flex-row align-items-center">
              <label className="col-form-label col-sm-3 text-end m-0 p-0 align-self-start pt-2">
                {t("storeMall.storeDetail.inquiry.packingStatus")}
              </label>
              <div className="col-sm-9 m-0 p-0 pl-2">
                <input
                  type="text"
                  className="form-control"
                  placeholder={t(
                    "storeMall.storeDetail.inquiry.packingStatusPlaceholder"
                  )}
                  ref={controller.srPacking}
                />
              </div>
            </div>
          </div>

          <div className="px-3">
            <div className="mb-3 row d-flex flex-row align-items-center">
              <label className="col-form-label col-sm-3 text-end m-0 p-0 align-self-start pt-2">
                {t("storeMall.storeDetail.inquiry.storageLocation")}
              </label>
              <div className="col-sm-9 m-0 p-0 pl-2">
                <input
                  type="text"
                  className="form-control"
                  placeholder={t(
                    "storeMall.storeDetail.inquiry.storageLocationPlaceholder"
                  )}
                  ref={controller.srInOutType}
                />
              </div>
            </div>
          </div>

          <div className="px-3">
            <div className="mb-3 row d-flex flex-row align-items-center">
              <label className="col-form-label col-sm-3 text-end m-0 p-0 align-self-start pt-2">
                {t("storeMall.storeDetail.inquiry.bondedYN")}
              </label>
              <div className="col-sm-9 m-0 p-0 pl-2">
                <select className="form-control" ref={controller.srCustomsYN}>
                  <option value="">
                    {t("storeMall.storeDetail.inquiry.bondedSelect")}
                  </option>
                  <option value="Y">
                    {t("storeMall.storeDetail.inquiry.bondedY")}
                  </option>
                  <option value="N">
                    {t("storeMall.storeDetail.inquiry.bondedN")}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div className="px-3">
            <div className="mb-3 row d-flex flex-row align-items-center">
              <label className="col-form-label col-sm-3 text-end m-0 p-0 align-self-start pt-2 ">
                {t("storeMall.storeDetail.inquiry.storagePeriod")}
              </label>
              <div className="col-sm-9 m-0 p-0 pl-2">
                <div className="d-flex flex-row justify-content-star align-items-center">
                  <input
                    className="form-control py-0 px-1"
                    type="date"
                    ref={controller.srStartDate}
                    defaultValue={new Date().toISOString().slice(0, 10)}
                  />
                  <span className="px-1">-</span>
                  <input
                    className="form-control py-0 px-1"
                    type="date"
                    ref={controller.srEndDate}
                    defaultValue={new Date().toISOString().slice(0, 10)}
                  />
                </div>
                <p className="p-0 m-0 text-danger">
                  {t("storeMall.storeDetail.inquiry.storagePeriodNote")}
                </p>
              </div>
            </div>
          </div>

          <div className="px-3">
            <div className="mb-3 row d-flex flex-row align-items-center">
              <label className="col-form-label col-sm-3 text-end m-0 p-0 align-self-start pt-2">
                {t("storeMall.storeDetail.inquiry.contactInfo")}
                <i style={{ color: "red", fontWeight: 700 }}>*</i>
              </label>
              <div className="col-sm-9 m-0 p-0 mb-2 pl-1">
                <input
                  type="text"
                  className="form-control"
                  placeholder={t(
                    "storeMall.storeDetail.inquiry.contactNamePlaceholder"
                  )}
                  ref={controller.srUserName}
                />
              </div>
              <label className="col-form-label col-sm-3 text-end m-0 p-0 align-self-start pt-2" />
              <div className="col-sm-9 m-0 p-0 mb-2 pl-1">
                <input
                  type="text"
                  className="form-control"
                  placeholder={t(
                    "storeMall.storeDetail.inquiry.contactEmailPlaceholder"
                  )}
                  ref={controller.srEmail}
                />
              </div>
              <label className="col-form-label col-sm-3 text-end m-0 p-0 align-self-start pt-2" />
              <div className="col-sm-9 m-0 p-0 pl-1">
                <input
                  type="text"
                  className="form-control"
                  placeholder={t(
                    "storeMall.storeDetail.inquiry.contactPhonePlaceholder"
                  )}
                  ref={controller.srMobile}
                />
              </div>
            </div>
          </div>

          <div className="px-3">
            <div className="mb-3 row d-flex flex-row align-items-center">
              <label className="col-form-label col-sm-3 text-end m-0 p-0 align-self-start pt-2">
                {t("storeMall.storeDetail.inquiry.etcInquiry")}
              </label>
              <div className="col-sm-9 m-0 p-0 pl-1">
                <textarea
                  className="form-control"
                  rows="5"
                  placeholder={t(
                    "storeMall.storeDetail.inquiry.etcInquiryPlaceholder"
                  )}
                  ref={controller.srDesc}
                />
              </div>
            </div>
          </div>

          <div className="d-flex flex-row justify-content-end">
            <div
              className="btn_1 outline mr-2"
              onClick={() => {
                clearInquiryInput();
              }}
            >
              {t("storeMall.storeDetail.inquiry.resetBtn")}
            </div>
            <div
              className="btn_1"
              onClick={() => {
                actionSubmit();
              }}
            >
              {t("storeMall.storeDetail.inquiry.submitBtn")}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
